module.exports = __webpack_public_path__ + "img/bgtop.c6f58057.png";